import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Modal } from 'antd';
import { FaBars } from 'react-icons/fa';
import './MobileNavbarAluminiCSS.css'; 

function MobileNavbarAlumini() {
  const [isOpen, setIsOpen] = useState(false);
  const [isModalVisible, setIsModalVisible] = useState(false);
  const navigate = useNavigate();

  const toggleNavbar = () => setIsOpen(!isOpen);

  const userdata = sessionStorage.getItem('userdata');

  const showLogoutModal = () => setIsModalVisible(true);

  const handleLogout = () => {
    sessionStorage.clear();
    setIsModalVisible(false);
    navigate('/');
  };

  const handleCancel = () => setIsModalVisible(false);

  useEffect(() => {
    if (!userdata) {
      sessionStorage.clear();
      navigate('/');
    }
  }, []);

  const handleNavigate = (path) => {
    window.location.href = `/#${path}`;
    setIsOpen(false);
  };

  return (
    <div className="mobile-navbar-container" style={{ backgroundColor: '#fff', borderBottom: '1px solid #ddd' }}>
      <div
        className="mobile-navbar-header"
        style={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'end',
          padding: '10px 15px',
          backgroundColor: '#000',
          color: '#fff',
        }}
      >
        {/* <h4 style={{ margin: 0, fontWeight: 'bold',color:"white" }}>WEL-COME</h4> */}
        <FaBars size={20} onClick={toggleNavbar} style={{ cursor: 'pointer' }} />
      </div>

      {isOpen && (
        <div className="mobile-navbar-links" style={{ padding: '10px', backgroundColor: '#a2d6f8',color:"black" }}>
          <div className="nav-link" onClick={() => handleNavigate('/AluminiDashboard')}>
            <i className="fa fa-line-chart me-2"></i> Dashboard
          </div>
          <div className="nav-link" onClick={() => handleNavigate('/Jobpost')}>
            <i className="fa-solid fa-folder-plus me-2"></i> Job Post
          </div>
          <div className="nav-link" onClick={() => handleNavigate('/AluminiAllJob')}>
            <i className="fa-solid fa-list me-2"></i> Jobs
          </div>
          <div className="nav-link" onClick={() => handleNavigate('/GalleryAlumini')}>
            <i className="fa-solid fa-image me-2"></i> Gallery
          </div>
          <div className="nav-link" onClick={() => handleNavigate('/Suggestion')}>
            <i className="fa-solid fa-file-circle-plus me-2"></i> Suggestion Form
          </div>
          {/* <div className="nav-link" onClick={() => handleNavigate('/EditAluminiProfile')}>
            <i className="fa-solid fa-user-pen me-2"></i> Edit Profile
          </div> */}
          <div className="nav-link" onClick={showLogoutModal}>
            <i className="fa-solid fa-circle-arrow-left me-2"></i> Log Out
          </div>
        </div>
      )}

      <Modal
        title="Confirm Logout"
        visible={isModalVisible}
        onOk={handleLogout}
        onCancel={handleCancel}
        okText="OK"
        cancelText="Cancel"
      >
        <p>Are you sure you want to log out?</p>
      </Modal>
    </div>
  );
}

export default MobileNavbarAlumini;
